/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ComparisonsControllerGetByIdQueryResponse, ComparisonsControllerGetByIdPathParams, ComparisonsControllerGetById400, ComparisonsControllerGetById401, ComparisonsControllerGetById403, ComparisonsControllerGetById404 } from "../../models/comparisonsController/ComparisonsControllerGetById";

function getComparisonsControllerGetByIdUrl(id: ComparisonsControllerGetByIdPathParams["id"]) {
  const res = { method: 'GET', url: `/api/v1/comparisons/${id}` as const }  
  return res
}

/**
 * @description Returns the full comparison record by its id.
 * @summary Get comparison by ID
 * {@link /api/v1/comparisons/:id}
 */
export async function comparisonsControllerGetById(id: ComparisonsControllerGetByIdPathParams["id"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<ComparisonsControllerGetByIdQueryResponse, ResponseErrorConfig<ComparisonsControllerGetById400 | ComparisonsControllerGetById401 | ComparisonsControllerGetById403 | ComparisonsControllerGetById404>, unknown>({ method : "GET", url : getComparisonsControllerGetByIdUrl(id).url.toString(), ... requestConfig })  
  return res.data
}